export const endpoints = {
  dashboardItem: 'dashboard',
  savedReports: (id: number) => `dashboard/${id}/savedReports`,
  favouriteExecute: 'statisticalReport',
  savedReportEvaluation: 'dashboard/report/evaluation',
  savedReportsOptions: 'validFavourite'
};
